export default "__VITE_ASSET__hvT8IzxI__"